export default __webpack_public_path__ + "static/shop-image2-a12dd497bf2962dd49a33a14349407b3.jpg";